import React, { useEffect, useState } from "react";
import { thirdparty } from "../.."; // Replace with your actual API handler
import { IMAGE_URL } from "../../constants"; // Replace with your actual constants
import { isIOS } from "react-device-detect";

const HomeModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [sliders, setSliders] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [modalInterval, setModalInterval] = useState(3000); // Default to 3 seconds

  useEffect(() => {
    // Check sessionStorage to see if the modal was closed
    const isModalClosed = sessionStorage.getItem("modalClosed");
    if (!isModalClosed) {
      setShowModal(true); // Show the modal if it wasn't closed
    }

    // Fetch slider data
    const fetchSliderData = async () => {
      try {
        const response = await thirdparty.get("/settings?type=popup_slider");
        if (response.status === 200) {
          setSliders(response.data);
        }
      } catch (error) {
        console.error("Error fetching slider data:", error);
      }
    };

    fetchSliderData();

    // Fetch modal interval
    const fetchModalInterval = async () => {
      try {
        const response = await thirdparty.get("/settings/26");
        if (response.status === 200) {
          setModalInterval(parseInt(response.data.value) * 1000);
        }
      } catch (error) {
        console.error("Error fetching modal interval:", error);
      }
    };

    fetchModalInterval();
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    sessionStorage.setItem("modalClosed", "true"); // Mark modal as closed in sessionStorage
  };

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("modal")) {
      handleCloseModal();
    }
  };

  const goToIndex = (index) => {
    if (index < 0) {
      index = sliders.length - 1; // Go to the last slide if index is less than 0
    } else if (index >= sliders.length) {
      index = 0; // Go to the first slide if index exceeds the length
    }
    setActiveIndex(index);
  };

  const nextSlide = () => {
    goToIndex(activeIndex + 1);
  };

  // Automatic slide transition
  useEffect(() => {
    if (showModal && sliders.length > 0) {
      const interval = setInterval(() => {
        nextSlide();
      }, modalInterval);

      return () => clearInterval(interval); // Clear the interval when the modal closes or unmounts
    }
  }, [showModal, activeIndex, modalInterval, sliders.length]);

  return (
    <div>
      {/* Modal */}
      {showModal && sliders.length > 0 && (
        <div
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={handleBackdropClick}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div
              className="modal-content border-0"
              style={{ backgroundColor: "transparent" }}
            >
              <div className="modal-body p-0">
                {/* Image Slider */}
                <div className="carousel slide">
                  <div className="carousel-inner">
                    {sliders.map((media, index) => (
                      <div
                        key={media.id}
                        className={`carousel-item ${
                          index === activeIndex ? "active" : ""
                        }`}
                      >
                        <img
                          src={`${IMAGE_URL}${media.file_path}`}
                          className="d-block w-100"
                          alt={`Slide ${index + 1}`}
                          style={{
                            height: "auto",
                            maxHeight: "80vh",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                  {/* Navigation Controls */}
                  <button
                    className="carousel-control-prev"
                    type="button"
                    onClick={() => goToIndex(activeIndex - 1)}
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    onClick={() => goToIndex(activeIndex + 1)}
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                  {/* Indicators */}
                  <div className="carousel-indicators">
                    {sliders.map((media, index) => (
                      <button
                        key={media.id}
                        type="button"
                        className={`indicator ${
                          index === activeIndex ? "active" : ""
                        }`}
                        aria-current={index === activeIndex}
                        aria-label={`Slide ${index + 1}`}
                        onClick={() => goToIndex(index)}
                        style={{
                          width: isIOS ? "2rem" : "12px",
                          height: isIOS ? "2rem" : "14px",
                          borderRadius: "50%",
                          margin: "0 5px",
                          backgroundColor:
                            index === activeIndex ? "#AF9763" : "#fff",
                          border: "1px solid #AF9763",
                          cursor: "pointer",
                        }}
                      ></button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeModal;



// WEBPACK FOOTER //
// ./src/component/frontend/HomeModal.js